var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, alias2=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pipeline-search-default\">\n    <div class=\"pipeline-search-item pipeline-search-item\">\n        <div class=\"pull-left pipeline-search-item-picture\">\n            <div class=\"photo-person-list\">\n                <img alt=\"\" class=\"img-circle\" src=\""
    + alias1(__default(require("../url.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"/assets/images/avatar.jpg",{"name":"url","hash":{},"data":data,"loc":{"start":{"line":5,"column":52},"end":{"line":5,"column":88}}}))
    + "\"></div>\n        </div>\n        <div class=\"pipeline-search-item-infos\">\n            <div class=\"pipeline-search-item-title highlightable\">\n                "
    + alias1(alias2((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0))
    + "\n            </div>\n            <div class=\"pipeline-search-item-subtitle highlightable\">\n                "
    + alias1(alias2((depth0 != null ? lookupProperty(depth0,"subtitle") : depth0), depth0))
    + "\n            </div>\n        </div>\n        <div class=\"clearfix\"></div>\n    </div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./resources/assets/javascript/templates/search/default.hbs
// module id = ./resources/assets/javascript/templates/search/default.hbs
// module chunks = 53